import { CONTENT_TYPES, MESSAGE_TYPES } from '../constants';

export function actionUrl(uri) {
  try {
    const url = new URL(uri);
    return ['https:', 'http:'].includes(url.protocol) ? url.href : null;
  } catch {
    return null;
  }
}

// Render the native structured payload, whether authored in Chatwoot or mirrored
// by a provider. An AgentBot is not an external echo and must not pretend to be one.
export function isInteractiveEcho(messageType, isPrivate, contentType, attrs) {
  if (
    messageType !== MESSAGE_TYPES.OUTGOING ||
    isPrivate ||
    attrs?.deleted ||
    !Array.isArray(attrs?.items) ||
    !attrs.items.length
  ) {
    return false;
  }
  if (contentType === CONTENT_TYPES.INPUT_SELECT) {
    return attrs.items.every(
      option =>
        typeof option?.title === 'string' && typeof option?.value === 'string'
    );
  }
  if (contentType === CONTENT_TYPES.CARDS) {
    return (
      attrs.items.every(card => Array.isArray(card?.actions)) &&
      attrs.items.some(card =>
        card.actions.some(
          action =>
            action?.type === 'link' &&
            typeof action.text === 'string' &&
            actionUrl(action.uri)
        )
      )
    );
  }
  return false;
}

export function externalMessageTime(createdAt, attrs) {
  const external = attrs?.externalEcho
    ? Date.parse(attrs.externalCreatedAt) / 1000
    : NaN;
  return Number.isFinite(external) ? external : createdAt;
}
